import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { useCreateModel } from '../api';
import { ModelForm } from '../components';

export const NewModelPage: FC = () => {
  const navigate = useNavigate();

  const {
    createModelMutation,
    refetchUploadUrl,
    uploadUrlData,
    isFetching,
    optionsData,
  } = useCreateModel();

  const saveModel = async (data) => {
    if (uploadUrlData?.modelId) {
      try {
        await createModelMutation.mutateAsync({
          ...data,
          id: uploadUrlData.modelId,
        });
        navigate(Routes.Models, { replace: true });
        toast.success(`Model “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  return (
    <ModelForm
      onSubmit={saveModel}
      options={optionsData}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="New Model"
          asChildPage
          backPath={Routes.Models}
          actions={[
            <Button
              key="create-model"
              type="submit"
              data-testid="create-model-button"
              isLoading={
                isFetching || createModelMutation.isPending || isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new model
            </Button>,
          ]}
        />
      )}
    </ModelForm>
  );
};
